import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import InstitutionSidebar from "../common/institutionSidebar";
import ProfileCard from "../common/profileCard";
import { Program } from "../../../core/types/types";
import { useSelector } from "react-redux";
import apiInstance from "../../../utility/apiInstance";
import { getCurrencySymbol } from "../../../utility/currencyUtils";
import AddProgramPopup from "./addProgramPopup";
import BackendImage from "../../../core/common/backendImage";
import BulkUploadPopup from "./bulkProgramUpload";
import Pagination from "../../../core/common/pagination/pagination";


const InstitutionPrograms = () => {

    const route = all_routes;
    const user = useSelector((state: any) => state.auth.user);
    const institution = user?.institution;
    const [programs, setPrograms] = useState<Program[]>([]);

    const [addPrgogramPopup, setAddPrgogramPopup] = useState<boolean>(false);
    const [bulkUploadPopup, setBulkUploadPopup] = useState(false);

    const [selectedProgram, setSelectedProgram] = useState<Program | null>(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);


    const addProgramHandler = (program: Program) => {
        setPrograms([program, ...programs]);
    }

    const programUpdateHandler = (program: Program) => {
        const updatedPrograms = programs.map((item) => item.id === program.id ? program : item);
        console.log(updatedPrograms)
        setPrograms(updatedPrograms);
    }

    const deleteProgramHandler = (program: Program) => {
        const updatedPrograms = programs.filter((item) => item.id !== program.id);
        setPrograms(updatedPrograms)
    }

    useEffect(() => {
        const fetchPrograms = async () => {
            try {
                const res = await apiInstance.get(
                    `/api/programs?where[institution][equals]=${institution.id}&page=${page}&limit=9`
                );
    
                setPrograms(res.data.docs);
                setTotalPages(res.data.totalPages);
                setHasNextPage(res.data.hasNextPage);
                setHasPrevPage(res.data.hasPrevPage);
    
            } catch (err) {
                console.error("Failed to fetch programs:", err);
            }
        };
    
        if (institution?.id) fetchPrograms();
    }, [institution?.id, page]);
    
    return (
        <>

            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <InstitutionSidebar />
                        {/* sidebar */}
                        {<div className="col-lg-9">
                            <div className="page-title d-flex flex-wrap gap-3 align-items-center justify-content-between">
                                <h5>All Programs</h5>
                                <div className="tab-list">
                                    <ul className="nav mb-0 gap-2" role="tablist">
                                        <li className="nav-item mb-0" role="presentation">
                                            <button
                                                onClick={() => {
                                                    setSelectedProgram(null)
                                                    setAddPrgogramPopup(true);
                                                }}
                                                className="btn btn-primary font-heading icon-send-letter">Add Program</button>
                                        </li>
                                        <li>
                                        <button
                                            onClick={() => setBulkUploadPopup(true)}
                                            className="btn btn-success"
                                            >
                                            Bulk Upload
                                            </button>
                                            </li>
                                           
                                    </ul>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade active show"
                                    id="enroll-courses"
                                    role="tabpanel"
                                >
                                    <div className="row">
                                        {programs.length > 0
                                            ? programs.map((program: Program) => (
                                                <div className="col-xl-4 col-md-6">
                                                    <div className="course-item-two course-item mx-0">
                                                        <div className="course-img">
                                                            <BackendImage
                                                                src={program?.image?.url}
                                                                alt="img"
                                                                className="img-fluid"
                                                                fallback="/assets/img/course-placeholder.png"
                                                            />
                                                        </div>
                                                        <div className="course-content">
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="ms-2">
                                                                        {program?.institution?.schoolName || ""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <h6 className="title mb-2" title={program?.programName || ""}>
                                                                {program?.programName || ""}
                                                            </h6>
                                                            <p className="d-flex align-items-center mb-3">
                                                                {program?.institution?.location || ""}
                                                            </p>
                                                            <p className="d-flex align-items-center mb-3 fw-bold">
                                                                {program?.programLevel || ""}
                                                            </p>
                                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                                <h6 className="text-primary mb-0">
                                                                    Application Fee
                                                                </h6>
                                                                <span>{program?.applicationFee ? `${getCurrencySymbol(program.institution?.country)}${program.applicationFee}` : "Free"}</span>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div>
                                                                    <h6 className="text-primary mb-0">
                                                                        Tuition Fee
                                                                    </h6>
                                                                    <small className="text-muted">
                                                                        (First year)
                                                                    </small>
                                                                </div>
                                                                <span>{program?.tuitionFee ? `${getCurrencySymbol(program.institution?.country)}${program.tuitionFee}` : "Free"}</span>
                                                            </div>
                                                            <hr></hr>
                                                            <div
                                                                onClick={() => {
                                                                    setSelectedProgram(program)
                                                                    setAddPrgogramPopup(true);
                                                                }}
                                                                className="btn mt-2 w-100 btn-secondary font-heading icon-send-letter"
                                                            >
                                                                Edit Program
                                                                <i className="isax isax-arrow-right-3 ms-1" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            : "No programs found."}
                                    </div>
                                </div>
                            </div>

                            <Pagination
                                page={page}
                                totalPages={totalPages}
                                setPage={setPage}
                                hasPrevPage={hasPrevPage}
                                hasNextPage={hasNextPage}
                            />

                        </div>}
                    </div>
                </div>
                <AddProgramPopup
                    show={addPrgogramPopup}
                    onClose={() => setAddPrgogramPopup(false)}
                    program={selectedProgram}
                    programUpdateHandler={programUpdateHandler}
                    deleteProgramHandler={deleteProgramHandler}
                    addProgramHandler={addProgramHandler}
                />
                <BulkUploadPopup
                    show={bulkUploadPopup}
                    onClose={() => setBulkUploadPopup(false)}
                    institutionId={institution?.id}
                    onBulkUploadComplete={(programs) => {
                        setPrograms([...programs, ...programs]);
                    }}
                />
            </div>
        </>
    );
};

export default InstitutionPrograms;
